import { render, staticRenderFns } from "./FilterableTableHeaderOptions.vue?vue&type=template&id=2b3af212&scoped=true&"
import script from "./FilterableTableHeaderOptions.vue?vue&type=script&lang=js&"
export * from "./FilterableTableHeaderOptions.vue?vue&type=script&lang=js&"
import style0 from "./FilterableTableHeaderOptions.vue?vue&type=style&index=0&id=2b3af212&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3af212",
  null
  
)

export default component.exports